import { getLenis } from "./lenis.js";

export function initAnchorScroll() {
  document.addEventListener("click", (e) => {
    const link = e.target.closest('a[href*="#"]');
    if (!link) return;

    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || url.pathname !== location.pathname)
      return;

    const hash = url.hash;
    if (!hash || hash === "#") return;

    const target = document.querySelector(hash);
    if (!target) return;

    e.preventDefault();

    const offset =
      -parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) ||
      0;

    const lenis = getLenis();
    if (lenis) {
      lenis.scrollTo(target, { offset });
    } else {
      const top =
        target.getBoundingClientRect().top + window.scrollY + offset;
      window.scrollTo({ top, behavior: "smooth" });
    }

    history.pushState(null, "", hash);
  });
}
